import styled from 'styled-components';
import { NeutralColors, RedColors } from 'theme';

const NotificationItemWrapper = styled.div<{ isUnread?: boolean }>`
  display: flex;
  align-items: flex-start;
  padding: 8px 20px;
  cursor: pointer;
  background-color: transparent;

  &:hover {
    background-color: ${(props) =>
      props.isUnread ? '#d5edff' : NeutralColors[10]};
  }
`;

const NotificationIcon = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 8px;
  background-color: ${NeutralColors[0]};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NotificationBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 8px;
  padding-right: 16px;
  flex: 1;
  min-width: 0;
`;

const NotificationTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${NeutralColors[100]};
  margin: 0;
`;

const NotificationDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${NeutralColors[80]};
  margin: 0;
`;

const NotificationTime = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: ${NeutralColors[60]};
  margin: 0;
`;

const UnreadDot = styled.div`
  width: 8px;
  height: 8px;
  min-width: 8px;
  border-radius: 50%;
  background-color: ${RedColors[50]};
  margin-top: 6px;
`;

export {
  NotificationBody,
  NotificationDescription,
  NotificationIcon,
  NotificationItemWrapper,
  NotificationTime,
  NotificationTitle,
  UnreadDot,
};
